import React, { memo } from "react";

const RangeCardMobile = ({ item, onBetting, isWin, oldResult }) => {
    if (!item) return null;

    const isWinner = isWin && oldResult?.numberCode === item.code;

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(item);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`rbm-range-card ${isWinner ? "is-winner" : ""}`}
        >
            <div className="rbm-range-card__title">{item.rangeNumber}</div>
            <div className="rbm-range-card__odds">{item.value}</div>
        </button>
    );
};

export default memo(RangeCardMobile);